module.exports = __webpack_public_path__ + "media/images/home/ic_image-94f45f4642adf20e3160d29cc70e737b.png";